/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { RecordId } from "../../commons/types/RecordId";
import { RecordDataWithLinks } from "./RecordDataWithLinks";
import { ValidationMessage } from "./ValidationMessage";
import { RecordConfig } from "./RecordConfig";
export const RecordWithLinks = core.serialization.object({
    id: RecordId,
    values: RecordDataWithLinks,
    valid: core.serialization.boolean().optional(),
    messages: core.serialization.list(ValidationMessage).optional(),
    metadata: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
    config: RecordConfig.optional(),
});
